<template>
<div>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="10" md="4">
      <v-card class="elevation-5 pt-5 pb-10 pl-5 pr-5">
        <v-img height="120" contain src="../../assets/Pelican_LogoB.png"></v-img>
        <!--<v-card-title v-text="card.cardTitle" class="font-weight-black justify-center"></v-card-title>-->
        <!--<v-card-subtitle v-text="card.cardSubTitle" class="font-weight-black text-center mt-0"></v-card-subtitle>-->
        <br /><br />
        <b>
          <font face="微軟正黑體" size="5" color="#555555">
            訂單已完成，謝謝您<br />
            如欲「修改資料」或「查詢貨態」<br />
            請再次掃描QRCode進入<br />
          </font>
          <br />
          <br />
          <center>
            <div v-if="this.SendCarflag===true">
              <v-btn color="#FF1B1B" width="250" x-large @click="btnSendCar()">
                <b>
                  <font color="#FEFEFE" size="5">通知派車</font>
                </b>
              </v-btn>
            </div>
            <div v-else>
              <v-btn width="250" x-large disabled>
                <b>
                  <font color="#FEFEFE" size="5">{{this.btntxt}}</font>
                </b>
              </v-btn>
            </div>
            <font face="微軟正黑體" size="4" color="#555555">
              08:00-15:00 開放通知取件
            </font>
          </center>
          <font face="微軟正黑體" size="4" color="#FF5252">
            提醒您：<br />
            <!--1.請聯繫負責站所或客服人員前往取件，亦可自行前往站所寄件。<br />
            2.包裹由司機或站所取件後，將無法自行修改，如欲修改請洽詢負責站所。<br />-->
            1.已點選 [通知派車]，如欲取消，請聯繫負責站所或客服人員。<br />
            2.未點選 [通知派車]，請聯繫負責站所或客服人員前往取件，亦可自行前往站所寄件。<br />
            3.包裹由司機或站所取件後，將無法自行修改，如欲修改請洽詢負責站所。<br />
          </font>
          <font face="微軟正黑體" size="5" color="#555555">
            自助語音預約寄件：<br />
          </font>
          <font face="微軟正黑體" size="5" color="#1976D2">
            02-4051-8588<br />
          </font>
        </b>
        <br />
        <center>
          <!--<a href="https://ecan.cyberbiz.co/">
            <v-img height="80" contain src="../assets/Pelican_logoEGO.png"></v-img>
          </a>
          <b>
            <font face="微軟正黑體" size="3" color="#555555">易購網</font>
          </b><br />-->
          <a href="https://www.e-can.com.tw/">
            <v-img height="80" contain src="../../assets/Pelican_IconLogo.png"></v-img>
          </a>
          <b>
            <font face="微軟正黑體" size="3" color="#555555">回官網</font>
          </b><br />
        </center>

        <v-row justify="center">
          <!--Dialog_託運注意事項-->
          <v-dialog v-model="dialog_SendCarflag" persistent max-width="600">
            <v-card>
              <v-card-title class="text-h5 primary">
                <font color="#FEFEFE">派 車 確 認</font>
              </v-card-title>
              <v-card-text>
                </br>
                <font size="4">
                  </br>前往收件地址：
                  </br>{{$cookie.get('start_cityname_token')}}{{$cookie.get('start_areaname_token')}}{{$cookie.get('start_addr_token')}}
                  </br>請問是否要派車?
                </font>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" x-large width="120" @click="btnSendCar_YES()">
                  <!--<v-btn color="primary" x-large width="120" @click="dialog_SendCarflag = false; SendCarflag=false; dialog_SendCarSuccess=true">-->
                  <font size="4">是 (YES)</font>
                </v-btn>
                <v-btn color="warning" x-large width="120" @click="dialog_SendCarflag=false; dialog_btnSendCar_NO=true">
                  <font size="4">否 (NO)</font>
                </v-btn>
              </v-card-actions></br>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog_btnSendCar_NO" persistent max-width="600">
            <v-card>
              <v-card-title class="text-h5 warning">
                <font color="#FEFEFE">派 車 取 消 通 知</font>
              </v-card-title>
              <v-card-text>
                </br>
                <font size="5">
                  </br>若非上述地址：</br>
                  </br>&ensp;1. 請修改寄件地址</br>
                  </br>&ensp;2. 請聯繫負責站所或客服人員</br>
                  </br>&ensp;以利派車
                </font>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" x-large width="120" @click="dialog_btnSendCar_NO=false">
                  <font size="4">離 開</font>
                </v-btn>
              </v-card-actions></br>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog_SendCarSuccess" persistent max-width="600">
            <v-card>
              <v-card-title class="text-h5 primary">
                <font color="#FEFEFE">派 車 成 功 通 知</font>
              </v-card-title>
              <v-card-text>
                </br>
                <font size="6">
                  </br>派車成功 !!</br>
                  </br>派車編號：<font color="#FF5252">{{this.MSGstring}}</font></br>
                  </br>如欲取消，請聯繫負責站所或客服人員
                </font>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" x-large width="120" @click="dialog_SendCarSuccess = false">
                  <font size="4">離 開</font>
                </v-btn>
              </v-card-actions></br>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog_SendCarError" persistent max-width="600">
            <v-card>
              <v-card-title class="text-h5 warning">
                <font color="#FEFEFE">派 車 失 敗 通 知</font>
              </v-card-title>
              <v-card-text>
                </br>
                <font size="6">
                  </br>派車失敗</br>
                  </br>{{this.MSGstring}}
                </font>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" x-large width="120" @click="dialog_SendCarError = false">
                  <font size="4">離 開</font>
                </v-btn>
              </v-card-actions></br>
            </v-card>
          </v-dialog>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</div>
</template>

<script>
export default {
  data() {
    return {
      SendCarflag: false,
      dialog_SendCarflag: false,
      dialog_SendCarSuccess: false,
      dialog_SendCarError: false,
      dialog_btnSendCar_NO: false,
      MSGstring: '',
      tempData_MainID: '',
      tempData_pickup_tel: '',
      btntxt: '通知派車'
    };
  },
  mounted: function() {
    this.chkSendCarflag();
  },
  methods: {
    data_08to15: function() {
      let date = new Date(Date.now());
      let year = date.getFullYear();
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();

      //return year.toString() + month.toString() + day.toString();
      if ((hours > 8) && (hours < 15)) {
        return true;
      } else {
        return false;
      }
    },
    chkSendCarflag: function() {
      if (this.data_08to15() === true) {
        /*let chkcusturl = 'https://queryapi.e-can.com.tw:9091/EDIQRAPI/EDIQR_SCchkCust/' + this.$cookie.get('accountId');
        this.$axios.get(chkcusturl).then(response => {
          this.custfilelstCust = response.data;
          //console.log(response.data);
          if (response.data.pcode === '1') {
            this.SendCarflag = true;
          } else {
            this.SendCarflag = false;
          };
        }).catch(
          console.log(error)
        )*/
        //let chkcusturl = 'https://queryapi.e-can.com.tw:9091/EDIQRAPI/EDIQR_SCchkCust';
        let chkcusturl = 'https://queryapi2.e-can.com.tw:9091/EDIQRAPI/EDIQR_SCchkCust';
        let axiosConfig = {
          headers: {
            'Content-Type': 'application/json'
          }
        };
        let postdata = JSON.stringify({
          "cust_id": this.$cookie.get('accountId'),
          "sendcar_addr": this.$cookie.get('start_cityname_token') + this.$cookie.get('start_areaname_token') + this.$cookie.get('start_addr_token')
        });
        if (((this.$cookie.get('start_cityname_token') + this.$cookie.get('start_areaname_token') + this.$cookie.get('start_addr_token')) !== '') && (this.$cookie.get('accountId') !== '')) {
          this.$axios.post(chkcusturl, postdata, axiosConfig).then((response) => {
              if (response.data.pcode === '1') {
                this.SendCarflag = true;
              } else {
                this.btntxt = '今日已通知';
                this.SendCarflag = false;
              };
            })
            .catch((error) => {
              console.log(error)
            });
        } else {
          this.SendCarflag = false;
        }
      } else {
        this.SendCarflag = false;
      }
    },
    btnSendCar: function() {
      if (this.data_08to15() === true) {
        this.SendCarflag = true;
        this.dialog_SendCarflag = true;
      } else {
        this.SendCarflag = false;
        this.dialog_SendCarError = true;
        this.MSGstring = '不再派車時段08:00-15:00';
      }
    },
    btnSendCar_YES: function() {
      let date = new Date(Date.now());
      let year = date.getFullYear();
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

      //let posturl = 'https://queryapi.e-can.com.tw:9091/EDIQRAPI/EDIQR_SendCar';
      let posturl = 'https://queryapi2.e-can.com.tw:9091/EDIQRAPI/EDIQR_SendCar';
      let axiosConfig = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      if (this.$cookie.get('dsmid_token').substr(1, 2) === '01') {
        this.tempData_MainID = '';
      } else {
        this.tempData_MainID = '115';
      };
      if (this.$cookie.get('start_phone_token') !== '') {
        this.tempData_pickup_tel = this.$cookie.get('start_phone_token');
      } else {
        this.tempData_pickup_tel = this.$cookie.get('start_telphone_token');
      };

      let postdata = JSON.stringify({
        "start_customer_id": this.$cookie.get('accountId'),
        "assign_record": "0",
        "source_type": "5",
        "check_pick": "0",
        "pickup_name": this.$cookie.get('start_name_token'),
        "pickup_tel": this.tempData_pickup_tel,
        "pickup_address": this.$cookie.get('start_cityname_token') + this.$cookie.get('start_areaname_token') + this.$cookie.get('start_addr_token'),
        "pickup_zipcode": this.$cookie.get('start_zpcode_token'),
        "delivery_sheet_main_id": this.tempData_MainID,
        "updatecode": "0",
        "passport_code": "0",
        "msg_code": "0",
        "unused_record": "0",
        "recordcode": ""
      });

      /*console.log(posturl);
      console.log(axiosConfig);
      console.log(postdata);*/

      if (this.data_08to15() === true) {
        if ((this.$cookie.get('start_cityname_token') + this.$cookie.get('start_areaname_token') + this.$cookie.get('start_addr_token')) !== '') {
          this.SendCarflag = false;
          this.dialog_SendCarflag = false;
          this.$axios.post(posturl, postdata, axiosConfig).then((response) => {
              console.log(response.data.desc);
              //this.SendCarflag = false;
              //this.dialog_SendCarflag = false;
              this.dialog_SendCarSuccess = true;
              this.MSGstring = response.data.desc;
              this.btntxt = '今日已通知';
            })
            .catch((error) => {
              console.log(error);
              //this.SendCarflag = false;
              //this.dialog_SendCarflag = false;
              this.dialog_SendCarError = true;
              this.MSGstring = '如欲派車，請聯繫負責站所或客服人員';
            });
        } else {
          //this.SendCarflag = false;
          //this.dialog_SendCarflag = false;
          this.dialog_SendCarError = true;
          this.MSGstring = '如欲派車，請聯繫負責站所或客服人員';
        }
      } else {
        //this.SendCarflag = false;
        this.dialog_SendCarError = true;
        this.MSGstring = '不再派車時段08:00-15:00';
      }

    },
  },
}
</script>
